export default {"src":"/_next/static/media/customized-iam-plan.bad963d4.svg","height":253,"width":253,"blurWidth":0,"blurHeight":0};